import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=c0b65a5c&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b65a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b65a5c')) {
      api.createRecord('c0b65a5c', component.options)
    } else {
      api.reload('c0b65a5c', component.options)
    }
    module.hot.accept("./AdditionalInformation.vue?vue&type=template&id=c0b65a5c&scoped=true", function () {
      api.rerender('c0b65a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/step3/AdditionalInformation.vue"
export default component.exports